import request from "@/utils/request";
import Qs from "qs";

// 用户签到列表
export function sign_list(data) {
  return request({
    url: "/user_sign/sign_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 用户签到配置列表
export function config_list(data) {
  return request({
    url: "/user_sign/config_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加用户签到配置
export function config_add(data) {
  return request({
    url: "/user_sign/config_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看用户配置详情
export function config_info(data) {
  return request({
    url: "/user_sign/config_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除用户签到配置
export function config_del(data) {
  return request({
    url: "/user_sign/config_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑用户签到配置
export function config_edit(data) {
  return request({
    url: "/user_sign/config_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
